















































































































import Vue from "vue";
import { ModalConfig } from ".";
import {
  computed,
  onMounted,
  onBeforeUnmount,
  ref,
  Ref,
} from "@vue/composition-api";
import { UseDevice } from "@/common/state/device.state";
import MobileModal from "@/components/mobile/MobileModal.vue";
import { emptyFn } from "@/fp";
import { onKey } from "@/common/dom.functions";
import Spinner from "@/components/Spinner.vue";
import { is_modal_on_top } from "./modal.state";
const DefaultConfig: ModalConfig = {
  title: "",
  desc: "",
  width: "",
  allowOverflow: false,
  height: "auto",
  blank: false,
  isLoading: false,
  backdropDismiss: true,
  disableSave: false,
  submitBtnText: "Submit",
  cancelBtnText: "Cancel",
};

export default Vue.extend({
  components: {
    MobileModal,
    Spinner,
  },
  props: ["config", "modalData"],
  setup(props, { emit }) {
    const modalRef: Ref<HTMLElement | null> = ref(null);
    const modal_wrapper: Ref<HTMLElement | null> = ref(null);
    const mergedConfig = computed(() => {
      return {
        ...DefaultConfig,
        ...(props.config as ModalConfig),
        ...((props.modalData as ModalConfig) || {}),
      };
    });

    const onBackDropClick = () => {
      if (mergedConfig.value.backdropDismiss) {
        emit("cancel");
      }
    };

    const subs = {
      esc: emptyFn(),
    };

    const make_sure_modal_stay_in_borders = () => {
      setTimeout(() => {
        if (modal_wrapper.value) {
          const { height, width } = modal_wrapper.value.getBoundingClientRect();
          if (height >= innerHeight) {
            modal_wrapper.value.style.height = innerHeight * 0.95 + "px";
            modal_wrapper.value.style.maxHeight = innerHeight * 0.95 + "px";
          }
          if (width >= innerWidth) {
            modal_wrapper.value.style.width = innerWidth * 0.9 + "px";
            modal_wrapper.value.style.maxWidth = innerWidth * 0.9 + "px";
          }
        }
      }, 200);
    };

    onMounted(() => {
      subs.esc = onKey("Escape")(() => {
        // @ts-ignore
        if (props.config.preventCloseWithEsc) {
          return;
        }
        if (modalRef.value) {
          if (is_modal_on_top(modalRef.value)) {
            onBackDropClick();
          }
        } else {
          onBackDropClick();
        }
      });

      make_sure_modal_stay_in_borders();
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    const { isMobile, isDesktop } = UseDevice();

    return {
      modalRef,
      modal_wrapper,
      mergedConfig,
      onBackDropClick,
      isMobile,
      isDesktop,
    };
  },
});
